import * as types from '../types';

export default {
  [types.GET_VISIT_LIST](state, data) {
    state.visitList = data;
  },
  [types.GET_STATISTICS_VISIT_TYPE](state, data) {
    state.visitTypeList = data.results;
  },
  [types.GET_SIGN_IN_LIST](state, data) {
    state.signInList = data;
  },
  [types.GET_SIGN_IN_DETAIL](state, data) {
    state.signInDetail = data;
  },
  [types.GET_SALESMAN_TABLE_DATA](state, data) {
    state.salesmanTableData = data;
  },
  [types.GET_BUSI_LINE_TABLE_DATA](state, data) {
    state.busiLineTableData = data;
  },
  [types.GET_CUSTOM_CLASSIFY_TABLE_DATA](state, data) {
    state.customTableData = data;
  },
  [types.GET_DEPA_BUSILINE_TABLE_DATA](state, data) {
    state.depaBusiLineTableData = data;
  },
  [types.GET_THREE_BUSILINE_TABLE_DATA](state, data) {
    state.threeBusiLineTableData = data;
  },
  [types.GET_DEPARTMENT_TABLE_DATA](state, data) {
    state.departmentTableData = data;
  },
  [types.GET_CUS_INSURANCE_TABLE_DATA](state, data) {
    state.cusInsuranceTableData = data;
  },
  [types.GET_CUS_BANK_TABLE_DATA](state, data) {
    state.cusBankTableData = data;
  },
  [types.GET_CUS_HEALTH_MANAGEMENT_TABLE_DATA](state, data) {
    state.cusHealManagementTableData = data;
  },
  [types.GET_CUS_INTERNET_TABLE_DATA](state, data) {
    state.cusInternetTableData = data;
  },
  [types.GET_CUS_OPRATION_TABLE_DATA](state, data) {
    state.cusOprationTableData = data;
  },
  [types.GET_DEP30F_BUS_PERFORMANCE_TABLE_DATA](state, data) {
    state.dep3OfBusPerformanceTableData = data;
  },
  [types.GET_CUSTOMER_REVENUE_TABLE_DATA](state, data) {
    state.customerRevenueTableData = data;
  },
  [types.GET_TIMING_RECORD_LIST](state, data) {
    state.timingRecordList = data;
  },
  [types.GET_TIMING_RECORD_TEAMS](state, data) {
    state.timingRecordTeams = data;
  },
  [types.GET_TIMING_RECORD_DETAIL](state, data) {
    state.timingRecordDetail = data.data;
  },
  [types.GET_PRO_ONLINE_TOP](state, data) {
    state.proOnlineTopData = data;
  },
  [types.GET_PRO_OFFLINE_TOP](state, data) {
    state.proOfflineTopData = data;
  },
  [types.GET_TEL_COUNSELING](state, data) {
    state.telCounselingTableData = data.data;
  },
  [types.GET_OFFLINE_SERVICE](state, data) {
    state.offlineServiceTableData = data;
  },
  [types.GET_CUSTOM_SELECT](state, data) {
    state.customSelectData = data;
  },
  [types.GET_DOCTEL_CONNECTION](state, data) {
    state.doctelConnectionList = data;
  },
  [types.GET_STATISTICS_TEAM_LIST](state, data) {
    state.statisticsTeamList = data;
  },
};
